import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import 'jquery-serializejson';
import 'jquery-validation';
import {DebtsService} from '../../../models/debts/debts.service';

@Component({
    selector: 'remove-modal',
    templateUrl: 'remove-modal.template.html',
    styleUrls: []
})

export class RemoveModalComponent implements OnInit, AfterViewInit {

    @Input()
    public transaction = <any> {};

    @Input()
    public type: 'payment' | 'log' = 'payment';

    constructor(public activeModal: NgbActiveModal, private debtsService: DebtsService) {


    }

    ngOnInit() {


    }

    ngAfterViewInit() {

    }


    // ===========================================================
    // Functions
    // ===========================================================


    loadData() {


    }


    // ===========================================================
    // Actions
    // ===========================================================

    isLoading: any = false;

    public removeTransaction() {
        if (this.isLoading) return;
        let fields = {
            item_type: this.type
        };

        this.isLoading = true;

        this.debtsService.removeTimelineItem(this.transaction.id, fields)
            .subscribe((res) => {
                this.activeModal.close(res.data);
                this.isLoading = false;
            });
    }


}


// WEBPACK FOOTER //
// ./src/app/modules/debt-account/remove-modal/remove-modal.component.ts